import { ApolloProvider } from "@apollo/client";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { nl } from "date-fns/locale/nl";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App.tsx";
import apolloClient from "./config/apollo.ts";
import { theme } from "./config/theme.ts";
import AuthContextProvider from "./modules/auth/context/AuthContextProvider.tsx";

import "./config/i18n.ts";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={nl}>
                <ApolloProvider client={apolloClient}>
                    <AuthContextProvider>
                        <App />
                    </AuthContextProvider>
                </ApolloProvider>
            </LocalizationProvider>
        </ThemeProvider>
    </StrictMode>,
);
